<script lang="ts">
  import { t } from '$lib/i18n/index.svelte';
  import { threadState } from '$lib/state/thread-state.svelte';

  let { accountId }: { accountId: string } = $props();

  const live = $derived(threadState.states[accountId]);
  const activity = $derived(live?.activity);

  // Two timing rules ported from the reference client: 300 ms settle before the
  // indicator appears (a status that flashes for a fast answer is noise), and the
  // elapsed counter only from 3 s (before that it says nothing useful).
  let visible = $state(false);
  let elapsedS = $state(0);

  $effect(() => {
    const current = activity;
    visible = false;
    elapsedS = 0;
    if (current === undefined) {
      return;
    }
    const settle = setTimeout(() => {
      visible = true;
    }, 300);
    const tick = setInterval(() => {
      elapsedS = Math.max(0, Math.floor((Date.now() - current.since.getTime()) / 1000));
    }, 1000);
    return () => {
      clearTimeout(settle);
      clearInterval(tick);
    };
  });
</script>

{#if activity !== undefined && visible}
  <div class="strip" role="status">
    <div class="row">
      <span class="note">{activity.note}</span>
      {#if elapsedS >= 3}
        <span class="elapsed">{elapsedS} s</span>
      {/if}
    </div>
    {#if activity.progress !== undefined}
      <div class="bar"><div class="fill" style="width: {activity.progress}%"></div></div>
    {:else}
      <div class="bar indeterminate"><div class="fill"></div></div>
    {/if}
  </div>
{:else if live?.answeredBy === 'human'}
  <div class="strip human" role="status">{t('conv.personAnswering')}</div>
{/if}

<style>
  .strip {
    padding: 8px 16px;
    background: var(--surface-2);
    font-size: 13px;
    color: var(--ink-soft);
  }
  .row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 6px;
  }
  .note {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .bar {
    height: 3px;
    border-radius: 2px;
    background: var(--line);
    overflow: hidden;
  }
  .fill {
    height: 100%;
    background: var(--brand);
    transition: width 0.3s;
  }
  .indeterminate .fill {
    width: 30%;
    animation: slide 1.2s infinite ease-in-out;
  }
  @keyframes slide {
    0% {
      margin-left: -30%;
    }
    100% {
      margin-left: 100%;
    }
  }
  .human {
    color: var(--brand);
    font-weight: 600;
  }
</style>
